import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import AppShell from "./components/AppShell";
import Landing from "./pages/Landing";
import AuthPage from "./pages/Auth";
import Status from "./pages/Status";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Catalog from "./pages/Catalog";
import Telegram from "./pages/Telegram";
import Bots from "./pages/Bots";
import BotDetail from "./pages/BotDetail";
import Imports from "./pages/Imports";
import Upgrades from "./pages/Upgrades";
import Streaming from "./pages/Streaming";
import Reseller from "./pages/Reseller";
import Billing from "./pages/Billing";
import Settings from "./pages/Settings";
import Suporte from "./pages/Suporte";
import Uploads from "./pages/Uploads";
import Pastas from "./pages/Pastas";
import Capas from "./pages/Capas";
import Catalogo from "./pages/Catalogo";
import Agendadas from "./pages/Agendadas";
import Acessos from "./pages/Acessos";
import Fila from "./pages/Fila";
import AdminCliente from "./pages/AdminCliente";
import { Spinner } from "./components/common";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#07090e]">
        <Spinner />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <ThemeProvider>
        <BrowserRouter>
        <Toaster theme="dark" richColors position="top-right" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<AuthPage />} />
          <Route path="/status" element={<Status />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/app" element={<Protected><AppShell /></Protected>}>
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="bots" element={<Bots />} />
            <Route path="bots/:id" element={<BotDetail />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="admin" element={<Admin />} />
            <Route path="admin/cliente/:id" element={<AdminCliente />} />
            <Route path="catalog" element={<Catalog />} />
            <Route path="telegram" element={<Telegram />} />
            <Route path="upgrades" element={<Upgrades />} />
            <Route path="imports" element={<Imports />} />
            <Route path="streaming" element={<Streaming />} />
            <Route path="reseller" element={<Reseller />} />
            <Route path="billing" element={<Billing />} />
            <Route path="suporte" element={<Suporte />} />
            <Route path="uploads" element={<Uploads />} />
            <Route path="fila" element={<Fila />} />
            <Route path="agendadas" element={<Agendadas />} />
            <Route path="pastas" element={<Pastas />} />
            <Route path="catalogo" element={<Catalogo />} />
            <Route path="capas" element={<Capas />} />
            <Route path="acessos" element={<Acessos />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </BrowserRouter>
        </ThemeProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
